import { ax } from '../../client.js'
import serviceURLS from './serviceURLS.js'

export const getPendingETRSettlements = (pagination) => {
  return ax.get(serviceURLS.GET_PENDING_ETR_SETTLEMENTS, { params: pagination })
}

export const acceptETRSettlement = (settlementId, invoice_id) => {
  return ax.post(
    serviceURLS.ACCEPT_ETR_SETTLEMENTS.replace(':id', invoice_id),
    {
      event_id: settlementId
    }
  )
}

export const rejectETRSettlement = (
  settlementId,
  invoice_id,
  settle_amount
) => {
  return ax.post(
    serviceURLS.REJECT_ETR_SETTLEMENT.replace(':id', invoice_id),
    {
      event_id: settlementId,
      settlement_amount: settle_amount
    }
  )
}

export const getPendingETPSettlements = (pagination) => {
  return ax.get(serviceURLS.GET_PENDING_ETP_SETTLEMENTS, {
    params: { ...pagination }
  })
}

export const acceptETPSettlements = (etp_ids) => {
  return Promise.all(
    etp_ids.map((etp_id) =>
      ax.put(serviceURLS.ACCEPT_ETP_SETTLEMENT.replace(':id', etp_id))
    )
  )
}

export const rejectETPSettlements = (etp_ids) => {
  return Promise.all(
    etp_ids.map((etp_id) =>
      ax.put(serviceURLS.REJECT_ETP_SETTLEMENT.replace(':id', etp_id))
    )
  )
}
